import { render, staticRenderFns } from "./OrderAdd.vue?vue&type=template&id=3f23aa35&scoped=true&"
import script from "./OrderAdd.vue?vue&type=script&lang=js&"
export * from "./OrderAdd.vue?vue&type=script&lang=js&"
import style0 from "./OrderAdd.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./OrderAdd.vue?vue&type=style&index=1&id=3f23aa35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f23aa35",
  null
  
)

export default component.exports